"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPublishedSitePagesById = exports.fetchPublishedSitePages = void 0;

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var fetchPublishedSitePages = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getPublishedPages,
  initiatingActionType: _actions.SitePagesActionTypes.FETCH_PUBLISHED_SITE_PAGES,
  requestStatusSelector: _selectors.getFetchPublishedPagesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestActions: _actions.FetchPublishedSitePages
}));
exports.fetchPublishedSitePages = fetchPublishedSitePages;
var fetchPublishedSitePagesById = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getPublishedPages,
  initiatingActionType: _actions.SitePagesActionTypes.FETCH_PUBLISHED_SITE_PAGES_BY_ID,
  requestStatusSelector: _selectors.getFetchPublishedPagesByIdRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestActions: _actions.FetchPublishedSitePagesById
}));
exports.fetchPublishedSitePagesById = fetchPublishedSitePagesById;